<template>
  <fragment>
    <div class="main_page">
      <app-navbar></app-navbar>
      <div class="page">
        <loading :active.sync="isPageLoading" is-full-page></loading>
        <div v-if="!isPageLoading">
          <div class="page-title">
            <h1>Procurement Types</h1>
          </div>
          <div class="page-content">
            <form>
              <div class="form-group row">
                <label for="searchKeyword" class="col-sm-2 col-form-label">Search by Keyword</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="searchKeyword" />
                </div>
                <div class="col-sm-2">
                  <button type="button" class="btn btn-primary" @click="newProcurementType">
                    <i class="fas fa-plus-circle"></i> Add New
                  </button>
                </div>
              </div>
            </form>
            <ul class="list-group list-group-flush border-bottom">
              <li class="list-group-item d-flex px-2" v-for="procurementType in searchLocalDataset(getProcurementTypes)" :key="procurementType.id">
                <div class="mr-auto">
                  <p class="m-0">{{ procurementType.name }}</p>
                </div>
                <a role="button" href="#" class="d-flex justify-content-between align-items-center flex-column"
                    title="Edit" @click.prevent="editProcurementType(procurementType.id)">
                  <img class="mb-1" src="@/assets/document.svg" alt />
                  <span class="small-grey">Edit</span>
                </a>
                <a role="button" href="#" class="d-flex justify-content-between align-items-center flex-column ml-3"
                    title="Delete" @click.prevent="deleteProcurementType(procurementType.id)">
                  <img class="mb-1" src="@/assets/red_x.svg" alt />
                  <span class="small-grey">Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-procurement-type" size="lg" hide-header hide-footer :no-close-on-backdrop="true">
      <procurement-type></procurement-type>
    </b-modal>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MessageBox from "@/utils/messagebox";
import Toast from "@/utils/toast";

export default {
  name: "configuration-procurement-types",
  components: {
    'app-navbar': () => import('@/components/app-navbar.vue'),
    'procurement-type': () => import('@/views/configuration/components/procurement-type.vue')
  },
  data: function() {
    return {
      isPageLoading: true,
      searchKeyword: null
    };
  },
  computed: {
    ...mapGetters(["getProcurementTypes"])
  },
  methods: {
    newProcurementType() {
      this.resetProcurementType().then(() => {
        this.$bvModal.show("bv-modal-procurement-type");
      });
    },
    editProcurementType(id) {
      this.fetchProcurementType(id).then(() => {
        this.$bvModal.show("bv-modal-procurement-type");
      });
    },
    async deleteProcurementType(id) {
      let confirm = await MessageBox.confirm(this, "Remove Procurement Type", "Are you sure you want to remove procurement type?");

      if (confirm) {
        this.removeProcurementType(id).then(() => {
          Toast.success(this, "Successfully removed procurement type!");
        });
      }
    },
    searchLocalDataset(values) {
      if (!this.searchKeyword || this.searchKeyword === "") return values;

      return values.filter(i => i.name.includes(this.searchKeyword));
    },
    ...mapActions(["fetchProcurementType", "fetchProcurementTypes", "removeProcurementType", "resetProcurementType"])
  },
  created: function() {
    this.fetchProcurementTypes().then(() => {
      this.isPageLoading = false;
    });
  }
};
</script>
